




































import { Vue, Component, Prop } from "vue-property-decorator";
import { formatMoney, objectify } from "@/helpers";

@Component
export default class PerformanceTodayCard extends Vue {
  @Prop({ default: {} }) dashboardStats!: any;

  get commissionsToday() {
    return formatMoney(objectify(this.dashboardStats).commisions_today);
  }

  get totalSalesPremiumToday() {
    return formatMoney(objectify(this.dashboardStats).sales_premium_today);
  }

  get salesVolumeToday() {
    return objectify(this.dashboardStats).sales_volume_today
      ? objectify(this.dashboardStats).sales_volume_today
      : 0;
  }
}
